import { OnInit, Component } from "@angular/core";
import { PatientView } from "../../../model/patient/patient-view";
import { WizardStep } from "../../../wizard/wizard.component";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { StudyReportWizardService } from "../../../services/wizard/study-report/study-report.wizard.service";


@Component({
  selector: 'study-report-patient-component',
  templateUrl: './study-report-patient.component.html',
  styleUrls: ['./study-report-patient.component.css']
})
export class StudyReportPatientComponent implements OnInit, WizardStep {

  loading: boolean;
  completed: boolean;
  isInit: boolean;
  patient: PatientView;

  constructor(private studyReportWizardService: StudyReportWizardService
    , private notificationToastService: NotificationToastService) {

  }

  activate(): void {

  }

  save(): void {

  }

  get valid(): boolean {
    return this.completed;
  }


  async ngOnInit() {
    try {
      this.loading = true;
      this.patient = await this.studyReportWizardService.getPatientView();
      this.completed = true;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Paciente");
    } finally {
      this.loading = false;
    }
  }
}
